import React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card } from 'react-bootstrap';

import DocumentQuestions from './DocumentQuestions';
import DocumentHealthProfile from './DocumentHealthProfile';
import DocumentEncounter from './DocumentEncounter';
import DocumentHeader from './DocumentHeader';
import DocumentHPI from './DocumentHPI';
import PageBreak from './PageBreak';
import AppointmentDetails from './AppointmentDetails';

function DocumentData({ enableHPI }) {
  return <>
    <div className="col mb-2">
      <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>Document Data</h5>
    </div>

    <div className="col">
      <Accordion defaultActiveKey="questions">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="questions" className="bg-white">
            <strong>Questions</strong>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="questions">
            <Card.Body className="p-2 bg-light" style={{ maxHeight: '400px', overflow: 'scroll', borderTop: '1px solid #1AB2E9' }}>
              <DocumentQuestions />
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="encounter" className="bg-white">
            <strong>Encounter</strong>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="encounter">
            <Card.Body className="p-2 bg-light" style={{ maxHeight: '400px', overflow: 'scroll', borderTop: '1px solid #1AB2E9' }}>
              <DocumentEncounter />
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {enableHPI &&
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="hpi" className="bg-white">
              <strong>HPI</strong>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="hpi">
              <Card.Body className="p-2 bg-light" style={{ maxHeight: '400px', overflow: 'scroll', borderTop: '1px solid #1AB2E9' }}>
                <DocumentHPI />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        }

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="header" className="bg-white">
            <strong>Document Elements</strong>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="header">
            <Card.Body className="p-2 bg-light" style={{ maxHeight: '400px', overflow: 'scroll', borderTop: '1px solid #1AB2E9' }}>
              <AppointmentDetails />
              <PageBreak />
              <DocumentHeader />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  </>
}

const mapStateToProps = (state) => {
  const HPIquestions = state.questionnaire.current.item.filter((item) => {
    const isNote = item.extension.find((extension) => {
      return extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note' &&
        extension.valueBoolean;
    })

    return isNote;
  });

  return {
    enableHPI: HPIquestions.length > 0
  }
}

export default connect(mapStateToProps)(DocumentData);